import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { getRegPath } from "../../../constants";
import { GETTING_STARTED } from "../../../constants";

import Button from "../../../components/formElements/button/Button";

const StepTwo = ({ history }) => {
  return (
    <div className="container text-center" style={{ maxWidth: 550 }}>
      <Link
        className="link float-right position-absolute"
        style={{
          marginLeft: 331,
          color: "#42a8e3",
          textDecorationLine: "underline",
        }}
        to={getRegPath("/signin")}
      >
        Skip
      </Link>
      <h5 className="header mb-4">
        Hi there,
        <br /> I'm UrgiDoctor
      </h5>
      <p className="w-50 mx-auto">
        Online care to you is just a few clicks away.
      </p>

      <img src={GETTING_STARTED} alt="" />

      <Button
        label="Let's take a tour"
        className="mb-4 w-75"
        onClick={() => history.push(getRegPath("/step3/1"))}
      />
      <br />
      <Link className="link" to={getRegPath("")}>
        Take me back
      </Link>
    </div>
  );
};

export default withRouter(StepTwo);
